<template>
  <a-modal
    :visible="visible"
    title="计划执行时间"
    :confirm-loading="submitting"
    :mask-closable="false"
    ok-text="提交"
    cancel-text="关闭"
    @ok="handleSubmit"
    @cancel="handleClose"
  >
    <a-form :form="form" class="iotplt-compact-form">
      <a-form-item label="当前计划时间">
        <span>{{ record.scheduled_execute_at || '-' }}</span>
      </a-form-item>

      <a-form-item label="操作">
        <a-radio-group
          v-decorator="['action', {
            initialValue: 'cancel',
            rules: [{ required: true, message: '请选择操作' }],
          }]"
          @change="handleActionChange"
        >
          <a-radio value="cancel">取消任务</a-radio>
          <a-radio value="reschedule">调整时间</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item v-if="action === 'reschedule'" label="新计划时间">
        <a-date-picker
          style="width: 100%;"
          show-time
          format="YYYY-MM-DD HH:mm"
          :disabled-date="disabledDate"
          :disabled-time="disabledTime"
          v-decorator="['scheduled_execute_at', {
            rules: [
              { required: true, message: '请选择执行时间' },
              { validator: checkScheduledAt },
            ]
          }]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {
  cancelBatchScheduledNetDown,
  rescheduleBatchScheduledNetDown
} from '@/api/batch_operation_record'

export default {
  name: 'ManageScheduledExecuteAt',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    record: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'manage_scheduled_execute_at' }),
      submitting: false,
      action: 'cancel'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.action = 'cancel'
        this.$nextTick(() => {
          this.form.resetFields()
          this.form.setFieldsValue({ action: 'cancel' })
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },

    handleActionChange(e) {
      this.action = e.target.value
      if (this.action === 'reschedule' && this.record.scheduled_execute_at) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            scheduled_execute_at: this.$moment(this.record.scheduled_execute_at)
          })
        })
      }
    },

    disabledDate(current) {
      return current && current < this.$moment().startOf('day')
    },

    disabledTime(current) {
      if (!current) {
        return {}
      }
      const now = this.$moment()
      if (!current.isSame(now, 'day')) {
        return {}
      }
      const disabledHours = []
      for (let i = 0; i < now.hour(); i++) {
        disabledHours.push(i)
      }
      const disabledMinutes = (selectedHour) => {
        if (selectedHour > now.hour()) {
          return []
        }
        const minutes = []
        for (let i = 0; i <= now.minute(); i++) {
          minutes.push(i)
        }
        return minutes
      }
      return {
        disabledHours: () => disabledHours,
        disabledMinutes
      }
    },

    checkScheduledAt(rule, value, callback) {
      if (this.action !== 'reschedule') {
        callback()
        return
      }
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请选择执行时间')
        return
      }
      if (!value.isAfter(this.$moment())) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('执行时间必须晚于当前时间')
        return
      }
      callback()
    },

    handleSubmit() {
      if (this.submitting) {
        return
      }
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        if (values.action === 'cancel') {
          this.$confirm({
            title: '确认取消该整批定时断网任务？',
            content: '',
            okText: '确定',
            okType: 'danger',
            cancelText: '关闭',
            zIndex: 3000,
            onOk: () => this.submitCancel()
          })
          return
        }
        this.submitReschedule(values.scheduled_execute_at)
      })
    },

    submitCancel() {
      this.submitting = true
      return cancelBatchScheduledNetDown(this.record.id).then((res) => {
        if (res.code === 0) {
          this.$message.success('已取消整批定时任务')
          this.handleClose()
          this.$emit('completed')
        }
        this.submitting = false
      }).catch(() => {
        this.submitting = false
      })
    },

    submitReschedule(scheduledAt) {
      this.submitting = true
      const data = {
        scheduled_execute_at: scheduledAt.format('YYYY-MM-DD HH:mm:00')
      }
      rescheduleBatchScheduledNetDown(this.record.id, data).then((res) => {
        if (res.code === 0) {
          this.$message.success('计划执行时间已更新')
          this.handleClose()
          this.$emit('completed')
        }
        this.submitting = false
      }).catch(() => {
        this.submitting = false
      })
    }
  }
}
</script>
